export default __webpack_public_path__ + "static/writers-block-screenshot-31dd22bd9c1e6bd38592e505d63af3bc.png";